/** 从轮次列表的安全字段恢复已锁定的专家角色，不读取服务端运行快照。 */
export function resolveLockedExpertRole(session, roleOptions) {
  const roleId = Number(session?.presetRoleId || 0)
  if (session?.runtimeEngine !== 'mastra' || !Number.isSafeInteger(roleId) || roleId < 1) return null

  const option = Array.isArray(roleOptions)
    ? roleOptions.find(role => Number(role.id) === roleId)
    : null
  return {
    id: roleId,
    name: option?.name || `已绑定专家 #${roleId}`,
    type: 'base',
  }
}

/** 仅凭服务端投影的安全引用匹配模型卡片；不读取运行快照或 Key。 */
export function resolveLockedSessionModel(session, modelOptions) {
  const ref = session?.lockedModelRef
  if (session?.runtimeEngine !== 'mastra' || !ref || !Array.isArray(modelOptions)) return null
  if (!['personal', 'platform'].includes(ref.source) || typeof ref.modelGuid !== 'string') return null
  return modelOptions.find(model => ref.source === 'personal'
    ? model.modelRef?.source === 'personal' && model.modelRef.modelGuid === ref.modelGuid
    : !model.modelRef && model.guid === ref.modelGuid) || null
}
